module.exports = __webpack_public_path__ + "52ea523622e7e4b1bd84fe765c7b8a68.png";